import { InitResponse, Odds } from "generated/graphql";

class SessionHelper {
  beToken = "";
  balance = 0;
  pbfCoin = 0;
  isFTU = false;
  isNewFTU=false;
  operatorId = "";
  platformId = "";
  language = "";
  location = "";
  lobbyUrl = "";
  initData: InitResponse | undefined;
  oddsDetails: Odds | undefined;
  badge = "";
  kit = "";
  kitColor = "";
  minBet = "";
  maxBet = "";
  bankingUrl = "";
  kitColorDark = "";
  maxPayOut = 0;
  extraData = {
    team1Score: "",
    team2Score: "",
    balance: 0,
    isStartMatchFlowShow: false,
  };
  content = {} as any;
  currency = "";
  useCheat = false;
  showOpenCloseBalance = false;
  useAnalytics = true;
  currencyUseGrouping = true;
  coinPurchaseAllowed = true;
  isUnderMaintenance = false;
  underMaintenanceTitle = "";
  currencyLang = "";
  countryImgUrl = "";
  _id = "";
  hideResetBtn = true;
  showRtpGameRules = false;
  showEos = false;
  isCheckStartMatchFunctionalityEnabled = false;
  startMatchBtnRestriction = false;
  startMatchBtnDiv = 0;
  isStickyCtaEnabled = false;
  isTutorialVideoEnabled = false;
  isWorldCupMode = false;

  //@ts-ignore
  onSignIn({
    isStickyCtaEnabled,
    beToken,
    _id,
    balance,
    bankingUrl,
    pbfCoin,
    isFTU,
    isNewFTU,
    useCheat,
    operatorId,
    platformId,
    language,
    lobbyUrl,
    location,
    initData,
    badge,
    kit,
    kitColor,
    kitColorDark,
    extraData,
    content,
    currency,
    maxPayOut,
    useAnalytics,
    minBet,
    maxBet,
    currencyLang,
    currencyUseGrouping,
    coinPurchaseAllowed,
    showOpenCloseBalance,
    isUnderMaintenance,
    underMaintenanceTitle,
    countryImgUrl,
    hideResetBtn,
    showRtpGameRules,
    showEos,
    isCheckStartMatchFunctionalityEnabled,
    startMatchBtnRestriction,
    startMatchBtnDiv,
    isTutorialVideoEnabled,
    isWorldCupMode
  }: any) {
    this.isStickyCtaEnabled = isStickyCtaEnabled;
    this.beToken = beToken;
    this.balance = balance;
    this.pbfCoin = pbfCoin;
    this.isFTU = isFTU;
    this.isNewFTU = isNewFTU
    this.operatorId = operatorId;
    this.platformId = platformId;
    this.language = language;
    this.lobbyUrl = lobbyUrl;
    this.location = location;
    this.initData = initData;
    this.badge = badge || "";
    this.kit = kit || "";
    this.kitColor = kitColor || "";
    this.kitColorDark = kitColorDark || "";
    this.extraData = extraData || {};
    this.content = content;
    this.minBet = minBet;
    this.maxBet = maxBet;
    this.bankingUrl = bankingUrl;
    this._id = _id;
    this.maxPayOut = maxPayOut;
    this.currency = currency;
    this.useCheat = useCheat;
    this.useAnalytics = useAnalytics ?? this.useAnalytics;
    this.currencyUseGrouping = currencyUseGrouping;
    this.currencyLang = currencyLang ?? language;
    this.coinPurchaseAllowed = coinPurchaseAllowed;
    this.countryImgUrl = countryImgUrl;
    this.showOpenCloseBalance = showOpenCloseBalance;
    this.isUnderMaintenance = isUnderMaintenance;
    this.underMaintenanceTitle = underMaintenanceTitle;
    this.hideResetBtn = hideResetBtn;
    this.showRtpGameRules = showRtpGameRules;
    this.showRtpGameRules = showRtpGameRules;
    this.showEos = showEos;
    this.isCheckStartMatchFunctionalityEnabled = isCheckStartMatchFunctionalityEnabled;
    this.startMatchBtnRestriction = startMatchBtnRestriction;
    this.startMatchBtnDiv = startMatchBtnDiv;
    this.isTutorialVideoEnabled = isTutorialVideoEnabled;
    this.isWorldCupMode = isWorldCupMode;
  }

  updateOddDetails(oddsDetails: Odds) {
    this.oddsDetails = oddsDetails as Odds;
  }
}

export default new SessionHelper();
